const sidePanel = {
    isOpen: function (sidePanelName) {
        let sidePanel = $('[side-panel="' + sidePanelName + '"]');
        return sidePanel.length > 0 && sidePanel.eq(0).hasClass("open");
    },
    open: function (sidePanelName, keepSelector) {
        let sidePanelElement = $('[side-panel="' + sidePanelName + '"]');
        if (sidePanelElement.length === 0) {
            return;
        }
        sidePanelElement = sidePanelElement.eq(0);
        sidePanelElement.addClass("open");
    },
    toggle: function (sidePanelName, keepSelector) {
        let sidePanelElement = $('[side-panel="' + sidePanelName + '"]');
        if (sidePanelElement.length === 0) {
            return;
        }
        sidePanelElement = sidePanelElement.eq(0);
        let newStatusIsopen = !sidePanel.isOpen(sidePanelName);
        sidePanel.closeAll();
        if (newStatusIsopen) {
            sidePanel.open(sidePanelName);
        }
    },
    closeAll: function () {
        $("[side-panel]").removeClass("open");
    }
};

;(function( $ ) {
    $(window).load(function() {
        $("[side-panel-interaction]").css("cursor", "pointer");

        $("body").on("click", "[side-panel-interaction]", function () {
            sidePanel.toggle($(this).attr('side-panel-interaction'), $(this).attr('side-panel-element-keep'));
        });

        $("body").on("click", ".close-side-panel", function () {
            sidePanel.closeAll();
        });

        $('body').on('mousewheel', '.side-panel-content', function (e) {
            let event = e.originalEvent,
                d = event.wheelDelta || -event.detail;

            this.scrollTop += ( d < 0 ? 1 : -1 ) * 30;
            e.preventDefault();
        });
    });
}( jQuery ));